import { Box, Typography, useTheme } from "@mui/material";
import { Check } from "@mui/icons-material";

export default function BreadCrumbNumber({ active, number }) {
  const theme = useTheme();

  const backgroundColor =
    active >= number ? theme.palette.primary.main : theme.palette.grey.light;

  if (active > number) {
    return (
      <Box
        sx={{
          backgroundColor: backgroundColor,
          color: "white",
          borderRadius: "50%",
        }}
        style={{ height: 24, width: 24, marginRight: 8, textAlign: "center" }}
      >
        <Check fontSize="small" color="white" />
      </Box>
    );
  } else {
    return (
      <Box
        sx={{
          backgroundColor: backgroundColor,
          color: "white",
          borderRadius: "50%",
        }}
        style={{ height: 24, width: 24, marginRight: 8, textAlign: "center" }}
      >
        <Typography variant={"body1"}>{number}</Typography>
      </Box>
    );
  }
}
